var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { ETeam } from '../../../../types';
import { useAppDispatch, useAppSelector } from '../../../../hooks';
import { selectMatchState, setMatchState } from '../../../../store/match';
import { useErrorHandler } from '../../../../hooks/useErrorHandler';
import { endSheriffCheck } from '../../../../api';
const Wrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 24px;
`;
const paperStyles = {
    padding: '48px 56px',
    minWidth: '480px',
    maxWidth: '640px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '16px',
};
const Result = styled(Typography) `
  && {
    font-size: 32px;
    font-weight: 700;
    color: ${({ apparent }) => (apparent === ETeam.MAFIA ? '#CC8181' : '#81CC96')};
  }
`;
export function SheriffCheckResult() {
    const { errorHandler } = useErrorHandler();
    const dispatch = useAppDispatch();
    const matchState = useAppSelector(selectMatchState);
    const matchId = (matchState === null || matchState === void 0 ? void 0 : matchState.id) || '';
    const sheriffData = matchState === null || matchState === void 0 ? void 0 : matchState.state;
    const check = sheriffData === null || sheriffData === void 0 ? void 0 : sheriffData.currentCheck;
    const target = check ? matchState === null || matchState === void 0 ? void 0 : matchState.players.find((p) => p.id === check.targetId) : null;
    const apparentLabel = (check === null || check === void 0 ? void 0 : check.apparentTeam) === ETeam.MAFIA ? 'Мафия' : 'Мирный';
    const wasFooled = !!check && check.apparentTeam !== check.realTeam;
    const onDone = () => __awaiter(this, void 0, void 0, function* () {
        try {
            const result = yield endSheriffCheck(matchId);
            dispatch(setMatchState(result));
        }
        catch (err) {
            errorHandler(err);
        }
    });
    return (_jsx(Wrapper, { children: _jsxs(Paper, Object.assign({ sx: paperStyles }, { children: [_jsx(Typography, Object.assign({ variant: "h2" }, { children: "\u041F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u0448\u0435\u0440\u0438\u0444\u0430" })), check ? (_jsxs(_Fragment, { children: [_jsx(Typography, Object.assign({ variant: "h5" }, { children: (target === null || target === void 0 ? void 0 : target.player.gameName) || (target === null || target === void 0 ? void 0 : target.player.realName) || 'Игрок' })), _jsx(Result, Object.assign({ apparent: check.apparentTeam }, { children: apparentLabel })), wasFooled && (_jsx(Typography, Object.assign({ variant: "body1", sx: { color: '#CC8181', textAlign: 'center' } }, { children: "\u0428\u0435\u0440\u0438\u0444 \u043E\u0431\u043C\u0430\u043D\u0443\u0442 \u0441\u043F\u043E\u0441\u043E\u0431\u043D\u043E\u0441\u0442\u044C\u044E \u043A\u043E\u043C\u0430\u043D\u0434\u044B \u043C\u0430\u0444\u0438\u0438." })))] })) : (_jsx(Typography, Object.assign({ variant: "body1" }, { children: "\u041D\u0435\u0442 \u0434\u0430\u043D\u043D\u044B\u0445 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0438" }))), _jsx(Button, Object.assign({ variant: "contained", size: "large", onClick: onDone }, { children: "\u041A \u0432\u044B\u0431\u043E\u0440\u0443 \u0440\u043E\u043B\u0435\u0439" }))] })) }));
}
